module.exports = __webpack_public_path__ + "img/37540fa.png";